import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import SkeletonPart from './_skeleton-part.js'

export default {
  name: 'RaceCardsSkeleton',
  values: {
    numberOfCards: 3,
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          _mobile_padding: '0 8px',
          flexDirection: 'column',
        },
      },
    },
    titleContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          alignItems: 'center',
          minHeight: '40px',
        },
      },
    },
    title: {
      configSet: Text,
      configValues: {
        container: {
          padding: '8px',
        },
      },
    },
    cardsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          padding: '0 0 2px',
          overflow: 'hidden',
        },
      },
    },
    raceCardContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          boxSizing: 'border-box',
          width: '294px',
          height: '247px',
          padding: '8px',
          flexDirection: 'column',
          flexGrow: 0,
          flexShrink: 0,
        },
      },
    },
    raceHeaderContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexGrow: '0',
          flexShrink: '0',
          flexDirection: 'column',
          padding: '0 0 28px 0',
        },
      },
    },
    raceTitleSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '144px',
          height: '13px',
        },
      },
    },
    raceNameLabelSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '110px',
          height: '13px',
        },
      },
    },
    runnersContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
          padding: '0 0 24px 0',
        },
      },
    },
    runnerContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'row',
          alignItems: 'center',
        },
      },
    },
    silkSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '32px',
          height: '32px',
        },
      },
    },
    runnerNameContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    runnerHorseNameSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '128px',
          height: '14px',
        },
      },
    },
    runnerJockeyNameSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '90px',
          height: '14px',
        },
      },
    },
    selectionSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '60px',
          height: '40px',
        },
      },
    },
    showAllRunnersContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          width: '100%',
          height: '32px',
          padding: '0 0 8px 0',
          flexDirection: 'row',
          justifyContent: 'end',
          alignItems: 'center',
        },
      },
    },
    showAllRunnerSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '86px',
          height: '14px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
